import { createContext } from 'react';

const MoxiModalContext = createContext({
  task: null,
  concludedTask: null,
  taskQueue: null,
  robotId: '',
  isServiceAvailable: true,
});

export default MoxiModalContext;
